import { Static, Type } from '@sinclair/typebox';
import { makeNullable } from '../../utils/typeboxHelpers';

export const surveyScopeEntityTypeSchema = Type.Union([
    Type.Literal('elementCategory'),
    Type.Literal('element'),
    Type.Literal('unit'),
    Type.Literal('manifestation'),
]);

export type SurveyScopeEntityType = Static<typeof surveyScopeEntityTypeSchema>;

export const surveyScopeExclusionTableSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    surveyId: Type.String({ format: 'uuid' }),
    entityType: surveyScopeEntityTypeSchema,
    entityId: Type.String({ format: 'uuid' }),
    clientCompanyId: Type.String({ format: 'uuid' }),
    created_at: makeNullable(Type.String()),
    updated_at: makeNullable(Type.String()),
});

export type SurveyScopeExclusion = Static<typeof surveyScopeExclusionTableSchema>;
